<template>
  <div class="cert-card card flex-1 flex flex-col row-center col-center">
    <!--审核中状态-->
    <template v-if="auditStatus === companyCertifiedDict.PENDING.value">
      <i class="iconfont icon-time-circle-fill text-warning"></i>
      <div class="font-20 font-bold m-t-20">
        <span class="text-warning">审核中...</span>
        您提交的
        <span>{{ currentServiceLabel }}</span>
        身份认证会在
        <span class="text-warning">1</span>
        个工作日完成审核
      </div>
    </template>

    <!--审核通过状态-->
    <template v-else-if="auditStatus === companyCertifiedDict.PASS.value">
      <i class="iconfont icon--_check-circle-fill text-success"></i>
      <div class="font-20 font-bold m-t-16">
        <span>{{ currentServiceLabel }}</span> 审核通过
      </div>
    </template>

    <!--审核不通过状态-->
    <template v-else-if="auditStatus === companyCertifiedDict.REJECT.value">
      <i class="iconfont icon-close text-danger"></i>
      <div class="font-20 font-bold m-t-16">
        <span>{{ currentServiceLabel }}</span>审核不通过
      </div>
      <div class="reject-box m-t-12">
        不通过理由：
        <span class="text-info">{{ reasonText }}</span>
      </div>
    </template>

    <div class="m-t-40">
      <el-button
        v-if="showBackBtn"
        style="width: 120px"
        @click="$router.go(-1)"
      >返回上一页</el-button>
      <el-button
        v-if="auditStatus === companyCertifiedDict.REJECT.value"
        type="primary"
        style="width: 120px"
        @click="openIdentity"
      >重新开通</el-button>
    </div>
  </div>
</template>

<script>
// 工具函数
import { mapState } from 'vuex'

// api接口
import {
  getServiceAuditStatusApi,
  getLatestServiceAuditStatusApi,
  applyServiceApi
} from '@/api/company'

// 数据字典
import {
  companyCertifiedDict,
  serviceCertifiedDict
} from '@/dictionary/company'
import { workbenchServiceDict } from '@/dictionary/system'

export default {
  name: 'ServiceCertStatus',

  props: {
    serviceType: {
      type: [String, Number],
      default: ''
    },

    showBackBtn: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      // 数据字典
      companyCertifiedDict,

      // 审核信息
      auditStatus: '',
      reasonText: '',

      // 本地的服务类型
      baseServiceType: ''
    }
  },

  computed: {
    ...mapState('company', ['isPurchaser', 'isAgency', 'isSupplier']),

    currentServiceType() {
      return this.baseServiceType || this.serviceType
    },
    currentServiceLabel() {
      return workbenchServiceDict.translate(this.currentServiceType).label
    }
  },

  created() {
    this.getServiceAuditStatus()
  },

  methods: {
    // 重新开通身份
    async openIdentity() {
      if (!this.showBackBtn) {
        this.$emit('reSelect')
        return
      }

      if (
        !(await this.$systemConfirm(
          `是否申请开通${this.currentServiceLabel}身份`
        ))
      ) {
        return
      }

      applyServiceApi({ serviceType: this.currentServiceType })
        .then(res => {
          this.getServiceAuditStatus()
          this.$message.success('身份申请成功，请等待审核')
        })
        .catch(err => {
          this.$message.error(err?.message || err)
        })
    },

    // 获取服务认证的审核状态
    getServiceAuditStatus() {
      let requestApi = getServiceAuditStatusApi

      if (!this.serviceType) {
        requestApi = getLatestServiceAuditStatusApi
      }

      requestApi(this.serviceType)
        .then(res => {
          this.auditStatus = res?.data?.status || 0
          this.reasonText = res?.data?.auditInfo?.rejectMsg || ''
          this.baseServiceType = res?.data?.type

          // 一下为对旧数据的兼容（旧数据，已认证服务，但是审核表没有数据的情况）
          const identityDict = workbenchServiceDict.translate(this.identityValue)
          if (
            this[identityDict.certification] === serviceCertifiedDict.YES.value
          ) {
            this.auditStatus.status = companyCertifiedDict.PASS.value
          }
        })
        .catch(err => {
          this.$message.error(err?.message || '获取身份审核状态失败')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.cert-card {
  i {
    font-size: 64px;
    line-height: 1;
  }

  .reject-box {
    max-width: 640px;
    line-height: 22px;
  }
}
</style>
